import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile, isInAppWebView, getOSCode } from '../utils/deviceUtil';
import isEmpty from 'lodash/isEmpty';
import { sendEventLog } from '../utils/newTiaraUtil';
import { androidInstallUrl, iosInstallUrl } from '../constants/Urls';
import openWithAppTalk from '../utils/openWithAppTalk';
import urlencode from 'urlencode';

export default class PfLinkBridgePage extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpenWithKakaoTalkApp = this.handleOpenWithKakaoTalkApp.bind(this);
    this.handleOpenInstallKakaoTalkPage = this.handleOpenInstallKakaoTalkPage.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.renderVersionLow = this.renderVersionLow.bind(this);
    this.render400 = this.render400.bind(this);
    this.render404 = this.render404.bind(this);
    this.render500 = this.render500.bind(this);
    this.renderMobile = this.renderMobile.bind(this);
    this.renderPC = this.renderPC.bind(this);
  }

  componentDidMount() {
    const { device, error } = this.props;
    if (!error.size && isMobile(device)) {
      this.openApp();
    }
  }

  openApp() {
    const { device, url } = this.props;
    const customUrl = `inappbrowser?url=${urlencode(url)}`;
    const deviceOs = getOSCode(device);
    const scheme = deviceOs === 'iOS' ? process.env.REACT_APP_TALK_CUSTOM_SCHEME : 'kakaotalk';
    openWithAppTalk(device, customUrl, scheme, true);
  }

  handleClose(e) {
    e && e.preventDefault();
    sendEventLog('close');
    openWithAppTalk(this.props.device, 'web/close', 'kakaotalk');
  }

  handleOpenWithKakaoTalkApp(e) {
    e && e.preventDefault();
    sendEventLog('go_kakaotalk');
    this.openApp();
  }

  handleOpenInstallKakaoTalkPage(e) {
    e && e.preventDefault();
    sendEventLog('go_appstore');
    const { device } = this.props;
    window.open(device.getIn(['os', 'name']) === 'iOS' ? iosInstallUrl : androidInstallUrl);
  }

  handleReload(e) {
    e && e.preventDefault();
    sendEventLog('reload');
    location.reload();
  }

  renderVersionLow() {
    return (
      <div className="inner_cont">
        <strong className="tit_error">카카오톡 업데이트가 필요한 기능입니다</strong>
        <span className="txt_sub">최신버전의 카카오톡을 설치하셔야 합니다.</span>
        <a href="#none" name="go_appstore" className="link_util" onClick={this.handleOpenInstallKakaoTalkPage}>앱스토어로 이동</a>
      </div>
    );
  }

  render400(message) {
    if (isEmpty(message)) {
      return (
        <div className="inner_cont">
          <strong className="tit_error">이용이 제한되었습니다.</strong>
          <span className="txt_sub">
            도움이 필요하시면 고객센터로 문의해주세요.
          </span>
          <a href="#none" className="link_util" onClick={this.handleClose}>닫기</a>
        </div>
      );
    }
    return (
      <div className="inner_cont">
        <strong className="tit_error">정보를 불러올 수 없습니다.</strong>
        <span className="txt_sub">{message}</span>
        <a href="#none" className="link_util" onClick={this.handleClose}>닫기</a>
      </div>
    );
  }

  render401() {
    return (
      <div className="inner_cont">
        <strong className="tit_error">정보를 불러올 수 없습니다.</strong>
        <span className="txt_sub">인증 실패</span>
        <a href="#none" className="link_util" onClick={this.handleReload}>다시시도</a>
      </div>
    );
  }

  render404() {
    return (
      <div className="inner_cont">
        <strong className="tit_error">페이지를 찾을 수 없습니다.</strong>
        <span className="txt_sub">
          주소가 잘못 되었거나 페이지가 삭제되었을 수 있습니다.<br />
          주소가 정확한지 다시 한 번 확인해 주세요.<br />
        </span>
      </div>
    );
  }

  render500() {
    return (
      <div className="inner_cont">
        <strong className="tit_error">정보를 불러올 수 없습니다.</strong>
        <a href="#none" name="reload" className="link_util" onClick={this.handleReload}>다시시도</a>
      </div>
    );
  }

  renderMobile() {
    return (
      <div className="inner_cont">
        <strong className="tit_error">최신버전의 카카오톡에서 제공하는 기능입니다</strong>
        <span className="txt_sub">최신버전의 카카오톡을 설치하셔야 합니다.</span>
        <a href="#none" name="go_appstore" className="link_util" onClick={this.handleOpenInstallKakaoTalkPage}>카카오톡 설치하기</a>
        <div className="wrap_btn">
          <a href="#none" name="go_kakaotalk" className="link_util" onClick={this.handleOpenWithKakaoTalkApp}>카카오톡으로 열기</a>
        </div>
      </div>
    );
  }

  renderPC() {
    return (
      <div className="inner_cont">
        <strong className="tit_error">모바일에서 확인 가능한 링크입니다.</strong>
        <span className="txt_sub">주소가 정확한지 다시 한번 확인해주세요.</span>
      </div>
    );
  }

  render() {
    const { device, error } = this.props;
    let child = null;
    const errorMessage = error.get('message', '');
    const httpStatus = error.get('httpStatus');

    if (error.size) {
      if (httpStatus === 400) {
        child = this.render400(errorMessage);
      } else if (httpStatus === 404 || httpStatus === 403) {
        child = this.render404();
      } else if (httpStatus === 401) {
        child = this.render401();
      } else if (errorMessage === "Version Low") {
        child = this.renderVersionLow();
      } else {
        child = this.render500();
      }
    } else if (isMobile(device)) {
      child = this.renderMobile();
    } else {
      child = this.renderPC();
    }

    if (!child) {
      child = this.render500();
    }
    const isTalkWebView = isInAppWebView(device);
    return (
      <div id="kakaoWrap">
        <header id="kakaoHead" className="head_membership">
          <h1 className="screen_out">카카오톡</h1>
        </header>
        <hr className="hide" />
        <main id="kakaoContent">
          <article id="mArticle">
            <div className="info_error">
              {child}
            </div>
            {isTalkWebView && (
              <button type="button" name="bridge_close" className="ico_sync btn_close" onClick={this.handleClose}>닫기</button>
            )}
          </article>
        </main>
      </div>
    );
  }
}

PfLinkBridgePage.propTypes = {
  device: PropTypes.object.isRequired,
  url: PropTypes.string,
  error: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/containers/PfLinkBridgePage.js